var _path, _circle, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThingsToDo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1787_96720",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 10,
    width: 24,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 22C20.3956 22 18.5373 20.7699 17.6153 19H14.3847C13.4627 20.7699 11.6044 22 9.5 22C6.5 22 4 19.5 4 16.5C4 14.0106 5.72143 11.8655 8.02153 11.2074C8.00742 11.1405 8 11.0711 8 11C8 10.4477 8.44772 10 9 10H11C11.5523 10 12 10.4477 12 11H19C19 10.4477 19.4477 10 20 10H22C22.5523 10 23 10.4477 23 11L22.9997 11.0232C25.7726 11.282 28 13.6683 28 16.5C28 19.5 25.5 22 22.5 22ZM9.5 20C7.6 20 6 18.4 6 16.5C6 14.6 7.6 13 9.5 13C11.4 13 13 14.6 13 16.5C13 18.4 11.4 20 9.5 20ZM19 16.5C19 14.6 20.6 13 22.5 13C24.4 13 26 14.6 26 16.5C26 18.4 24.4 20 22.5 20C20.6 20 19 18.4 19 16.5ZM15 16C15 16.5429 15.4571 17 16 17C16.5429 17 17 16.5429 17 16C17 15.4571 16.5429 15 16 15C15.4571 15 15 15.4571 15 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1787_96720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThingsToDo);
export default __webpack_public_path__ + "static/media/icon_things-to-do.156a33205eabd5ddc78e3ca04eef0d5d.svg";
export { ForwardRef as ReactComponent };